import { Channel, ChannelTab, isDefaultChannelTab } from '@lessonup/typescript-core/domain';
import { channelRoute } from '@lessonup/typescript-core/services';
import { useOnClickOutside, CloseCrossSvg, useToggle } from '@lessonup/typescript-core/ui';
import { capitalize } from '@lessonup/typescript-core/utils';
import classNames from 'classnames';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { htmlDecode } from '../../utils/htmlDecode';
import './ChannelTabs.less';

interface ChannelTabsProps {
  channel: Channel;
  children?: React.ReactNode;
}

interface ChannelTabProps {
  tab: ChannelTab;
  active: boolean;
  className?: string;
  channelName: string;
}

const ChannelTabsList: React.FC<ChannelTabsProps> = (props) => {
  const { t } = useTranslation(['channel', 'common']);
  const [expandedMenu, toggleExpandedMenu] = useToggle(false);
  const ref = useRef<HTMLDivElement>(null);

  useOnClickOutside(ref, () => {
    if (expandedMenu) toggleExpandedMenu(false);
  });

  return (
    <div className={classNames('channel-tabs-list', { expanded: expandedMenu })} ref={ref}>
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events -- auto-generated TECH-258 */}
      <div className="d-sm-none small-screen-menu-toggle" onClick={() => toggleExpandedMenu()}>
        {expandedMenu ? <CloseCrossSvg /> : t('common:menu')}
      </div>
      <div className="channel-tabs">{props.children}</div>
    </div>
  );
};

export const ChannelTabItem: React.FC<ChannelTabProps & React.HTMLAttributes<HTMLDivElement>> = ({
  tab,
  active,
  className,
  channelName,
}) => {
  const route = isDefaultChannelTab(tab)
    ? channelRoute({ channelSlug: channelName, channelPage: tab.id })
    : channelRoute({ channelSlug: channelName, channelPage: 'series', selectionId: tab.id });

  return (
    <Link to={route}>
      <div className={classNames('channel-tab', className, { active })}>{capitalize(htmlDecode(tab.name) || '')}</div>
    </Link>
  );
};

export default ChannelTabsList;
